import { render } from "./ClientsInfoPage.vue?vue&type=template&id=6d3a0d9c&scoped=true"
import script from "./ClientsInfoPage.vue?vue&type=script&lang=js"
export * from "./ClientsInfoPage.vue?vue&type=script&lang=js"

import "./ClientsInfoPage.vue?vue&type=style&index=0&id=6d3a0d9c&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3a0d9c"]])

export default __exports__